<template>
  <div
    :class="['zg-form-element', {
      'zg-form-element--hidden': hidden,
      'zg-form-element--no-margin': noMargin,
      'zg-form-element--auto-width': autoWidth,
      'zg-form-element--full-width': fullWidth,
    }]"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'ZgFormElement',
    props: {
      hidden: {
        type: Boolean,
        required: false,
        default: false
      },
      noMargin: {
        type: Boolean,
        required: false,
        default: false
      },
      autoWidth: {
        type: Boolean,
        required: false,
        default: false
      },
      fullWidth: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-form-element {
    position: relative;
    width: 100%;
    margin: 0 0 rhythm();

    @include mq(medium) {
      width: input(width);
    }

    &--hidden {
      @include visuallyhidden;
    }

    &--no-margin {
      margin: 0;

      @include mq(medium) {
        margin: 0;
      }
    }

    &--auto-width {
      width: auto;

      @include mq(medium) {
        width: auto;
      }
    }

    &--full-width {
      width: 100%;

      @include mq(medium) {
        width: 100%;
      }
    }
  }
</style>
